import React from 'react';
import { Droppable as BeautifulDroppable } from 'react-beautiful-dnd';
import { css, cx } from 'emotion';
import PropTypes from 'prop-types';
import FlexBox from '../FlexBox';
import { horizon, ocean } from '../colors';
const droppableStyle = css({
    borderRadius: '3px',
    padding: '8px',
    minHeight: '64px',
});
const Droppable = ({ children, droppableId, isEmpty = false, emptyPlaceholder }) => (React.createElement(BeautifulDroppable, { droppableId: droppableId }, (provided, snapshot) => (React.createElement("div", { ref: provided.innerRef, className: cx('droppable', droppableStyle), style: {
        backgroundColor: snapshot.isDraggingOver ? horizon : '',
        border: isEmpty ? `2px dashed ${ocean.base}` : '',
    } },
    React.createElement(FlexBox, { isVertical: true, paddingY: "s", middle: isEmpty }, !isEmpty ? (React.createElement(React.Fragment, null,
        children,
        provided.placeholder))
        : (React.createElement(React.Fragment, null, emptyPlaceholder)))))));
Droppable.propTypes = {
    children: PropTypes.node,
    droppableId: PropTypes.string,
    isEmpty: PropTypes.bool,
    emptyPlaceholder: PropTypes.node,
};
export default Droppable;
